import { Stack, Text } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

// Types

export type StartingChatMessage = {
  id: string;
  title: string;
  shortTitle?: string;
  description?: string;
  content: string;
  preferenceId?: string;
  specTemplateId?: string;
};

type StartingChatMessageCardProps = {
  message: StartingChatMessage;
  onSelectMessage: (
    content: string,
    preferenceId?: string,
    starterId?: string,
    specTemplateId?: string,
  ) => void;
};

// Components

export const StartingChatMessageCard = ({
  message,
  onSelectMessage,
}: StartingChatMessageCardProps) => {
  const { t } = useTranslation();
  return (
    <Stack
      aria-label={t('chat.starters.starterAria', { title: message.title })}
      className="cursor-pointer rounded-lg border border-border-primary bg-bg-primary p-4 hover:border-border-secondary hover:bg-bg-secondary"
      key={message.id}
      onClick={() =>
        onSelectMessage(
          message.content,
          message.preferenceId,
          message.id,
          message.specTemplateId,
        )
      }
      gap={2}
      direction="horizontal"
    >
      <Stack gap={1}>
        <Text>{message.title}</Text>
        <Text color="tertiary">{message.description ?? message.content}</Text>
      </Stack>
    </Stack>
  );
};
